export const regExps = {
	email: /[\w-]+@([\w-]+\.)+[\w-]+/,
}
